let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e1CwV")).then(() => parcelRequire('gdI2D'));